import rpcCall, {abortCall} from '../rpc/rpcCalls'
import {ValidationErrors} from '../../panels/user/constants'
import StateComponent from '../../StateComponent'

const VALIDATE_PASSWORD_RPC = "PasswordValidationService.validatePassword";
const VALIDATE_PASSWORD_WITH_NEW_POLICY_RPC = "PasswordValidationService.validatePasswordWithNewPolicy";

function isEmpty(str) {
    return !str || !str.length;
}

export function validatePassword(password)
{
    cancelPasswordValidation();
    return rpcCall(VALIDATE_PASSWORD_RPC, [password]);
}

export function validatePasswordWithNewPolicy(password, policy)
{
    cancelPasswordValidation();
    return rpcCall(VALIDATE_PASSWORD_WITH_NEW_POLICY_RPC, [password, policy]);
}

export function cancelPasswordValidation()
{
    abortCall(VALIDATE_PASSWORD_RPC)
}

export function getPasswordValidator({
    validatePasswordCopy = true,
    ignoreBothEmptyness = false,
    validateWithNewPolicy = false,
    onValidationStart = () => {},
    onValidationEnd = (errorKey, restrictionResultJson = null) => {}
}) {
    return new PasswordAsyncValidator({
        validatePasswordCopy,
        ignoreBothEmptyness,
        remoteValidate: validateWithNewPolicy ? validatePasswordWithNewPolicy : validatePassword,
        onValidationStart,
        onValidationEnd,
    })

}

export default class PasswordAsyncValidator extends StateComponent
{
    constructor({
        validatePasswordCopy = true,
        ignoreBothEmptyness = false,
        remoteValidate = () => Promise.resolve({ok: true}),
        onValidationStart = () => {},
        onValidationEnd = (errorKey, restrictionResultJson = null) => {}
    } = {}) {
        super();
        this.state = {
            password: null,
            passwordCopy: null,

            validating: false,
            passwordIsOk: true,
            forcePasswordCheck: false,
            ignoreBothEmptyness,
            newPasswordPolicy: {},
        }
        this.validatePasswordCopy = validatePasswordCopy;
        this.onValidationEnd = onValidationEnd;
        this.onValidationStart = onValidationStart;
        this.remoteValidate = remoteValidate

        this.onStatePropertyChanged("password", this._doValidatePassword.bind(this));
        this.onStatePropertyBecameTrue("forcePasswordCheck", () => this._doValidatePassword(this.state.password));
        if (this.validatePasswordCopy) {
            this.onStatePropertyChanged("passwordCopy", passwordCopy => {
                if (this.state.validating || !this.state.passwordIsOk) return;
                this.onValidationStart();

                if (this._canIgnoreDueToBothEmpty()) return;
                this._checkPasswordCopy();
            });
        }
        this.resumeHandlingStateChanges(false);
    }

    _canIgnoreDueToBothEmpty() {
        if (this.validatePasswordCopy && this.state.ignoreBothEmptyness && isEmpty(this.state.password) && isEmpty(this.state.passwordCopy)) {
            this.setState({passwordIsOk: true});
            this.onValidationEnd(null);
            return true;
        }
        return false;
    }

    _doValidatePassword(password) {
        this.onValidationStart();
        this.setState({forcePasswordCheck: false});
        if (this._canIgnoreDueToBothEmpty()) return;
        if (isEmpty(password)) {
            this.setState({passwordIsOk: false});
            this.onValidationEnd(ValidationErrors.PASSWORD_EMPTY);
        } else {
            this.setState({validating: true});
            this.remoteValidate(password, this.state.newPasswordPolicy).then(result => {
                this.setState({validating: false, passwordIsOk: result.ok});
                if (result.ok) {
                    if (this.validatePasswordCopy) {
                        this._checkPasswordCopy();
                    } else {
                        this.onValidationEnd(null);
                    }
                } else {
                    this.onValidationEnd(ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED, result);
                }
            });
        }
    }

    init() {

    }

    _checkPasswordCopy() {
        if (isEmpty(this.state.passwordCopy)) {
            this.onValidationEnd(ValidationErrors.PASSWORD_COPY_EMPTY);
        } else if (this.state.passwordCopy !== this.state.password) {
            this.onValidationEnd(ValidationErrors.PASSWORDS_DO_NOT_MATCH)
        } else {
            this.onValidationEnd(null);
        }

    }

    static ValidationErrors = ValidationErrors;
}




// WEBPACK FOOTER //
// ./web/js/util/passwords/PasswordAsyncValidator.js